/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { ControlPanelConfig, sections,sharedControls, } from '@superset-ui/chart-controls';
import {
  t,
  validateNonEmpty,
} from '@superset-ui/core';
import {
  filterNulls,
  fillColorPicker,
  viewport,
  mapboxStyle,
} from '../../../legacy-preset-chart-deckgl/src/utilities/Shared_DeckGL';


const countyOptions = [['missouri','Missouri'],['utah','Utah']]

const config: ControlPanelConfig = {
  controlPanelSections: [
    sections.legacyRegularTime,
    {
      label: t('Query'),
      expanded: true,
      controlSetRows: [
        [
          {
            name: 'groupby',
            config: {
              ...sharedControls.groupby,
              label: t('County Column'),
              description: t(
                'Column containing ISO 3166-2 codes of region/province/department in your table.',
              ),
              multi: false,
              clearable: false,
              validators: [validateNonEmpty]
            }
          }
        ],
        ['metrics'],
        ['row_limit'],
        [filterNulls],
        ['adhoc_filters'],
      ],
    },
    {
      label: t('Select Region'),
      expanded: true,
      controlSetRows: [
        [
          {
            name: 'select_region',
            config: {
              type: 'SelectControl',
              label: t('Region'),
              default: null,
              choices: countyOptions,
              description: t('Which region to plot the map for?'),
              validators: [validateNonEmpty],
            },
          },
        ],
      ]
    },
    {
      label: t('Map'),
      controlSetRows: [[mapboxStyle, viewport,fillColorPicker]],
    },
  ],
};

export default config;
